import { ComponentPropsWithoutRef } from "react";
import { twMerge } from "tailwind-merge";
import {
  ButtonV2,
  OptionsSchedules,
  ScheduleDateBadge,
  StatusTagV2,
} from "../../Atoms";
import {
  IAgendamentoDTO,
  IIniciarAgendamentoProps,
} from "../../../types/agendamento";
import { TipoAtendimentoEnum } from "../../../enums/tipoAtendimento";

const TIPO_ATENDIMENTO_LABELS: Record<TipoAtendimentoEnum, string> = {
  [TipoAtendimentoEnum.LOJA]: "Loja",
  [TipoAtendimentoEnum.DOMICILIO]: "Domicílio",
  [TipoAtendimentoEnum.ITINERANTE]: "Itinerante",
};

interface IScheduleCardV2Props extends ComponentPropsWithoutRef<"div"> {
  agendamento: IAgendamentoDTO;
  onAssignSchedule: (data: IIniciarAgendamentoProps) => void;
  onStartSchedule: (data: IIniciarAgendamentoProps) => void;
}

export const ScheduleCardV2 = ({
  agendamento,
  onAssignSchedule,
  onStartSchedule,
  className,
  ...rest
}: IScheduleCardV2Props) => {
  const cidade =
    agendamento?.loja?.endereco?.cidade || agendamento?.delivery?.cidade || agendamento?.itinerante?.endereco?.cidade;

  return (
    <div
      {...rest}
      className={twMerge(
        "flex flex-col gap-4 rounded-[15px] border border-solid border-[#e5e5ea] bg-white p-5 sm:grid sm:grid-cols-[95px_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)] sm:items-center sm:gap-3",
        className,
      )}
    >
      <ScheduleDateBadge
        diaAgendado={agendamento?.diaAgendado}
        horaAgendada={agendamento?.horaAgendada}
      />

      <div className="flex min-w-0 flex-col gap-1">
        <span className="inline-flex w-fit items-center gap-1 rounded-full border border-solid border-[#e5e5ea] bg-[#fafcfe] px-2.5 py-0.5 font-['Mulish'] text-xs text-[#2d2d2d]">
          <img
            src="/assets/svgs/icon-place.svg"
            alt=""
            className="h-2.5 w-2.5"
          />
          {TIPO_ATENDIMENTO_LABELS[agendamento?.tipoAtendimento]}
        </span>
        <span className="font-['Mulish'] text-base font-bold text-[#2d2d2d]">
          {agendamento?.veiculo?.modelo}
          {(agendamento?.veiculo?.placa || agendamento?.veiculo?.chassi) &&
            ` - ${agendamento.veiculo.placa || agendamento.veiculo.chassi}`}
        </span>
        <span className="font-['Mulish'] text-[10px] text-[#2d2d2d]">
          {agendamento?.servico?.nome}
        </span>
        <span className="font-['Mulish'] text-[10px] text-[#2d2d2d]">
          {cidade}
        </span>
      </div>

      <div className="flex sm:justify-end">
        <StatusTagV2 status={agendamento?.status} />
      </div>

      <div className="flex items-center justify-end gap-3">
        <ButtonV2
          href={`/meus-agendamentos/agendamento?id=${agendamento?.uuid}`}
          target="_blank"
          rel="noreferrer"
          variant="text"
          aria-label="Visualizar agendamento"
          className="h-auto w-auto min-w-0 p-0"
        >
          <img src="/assets/svgs/eye.svg" alt="icone visualizacao" />
        </ButtonV2>

        <OptionsSchedules
          agendamento={agendamento}
          onAssignSchedule={onAssignSchedule}
          onStartSchedule={onStartSchedule}
        />
      </div>
    </div>
  );
};
